import { colorOpacity, customTheme } from 'theme';

const fontSize = '16px';
export const defaultSelectStyles = (
  height?: string | number,
  showTotalSelected = false,
  isAFilter = false,
  hasLeftMessage = false,
  showBorder = true,
) => ({
  menu: provided => {
    return {
      ...provided,
      width: 'max-content',
      minWidth: '100%',
      zIndex: 999,
      fontSize: fontSize,
      paddingTop: 3,
      paddingBottom: 2,
      paddingRight: 12,
      paddingLeft: 12,
    };
  },
  menuPortal: provided => ({ ...provided, zIndex: 9999 }),
  groupHeading: provided => ({ ...provided, paddingLeft: 0, paddingRight: 0 }),

  option: (provided, { isSelected, isDisabled, isMulti }) => {
    return {
      ...provided,
      '&:active': {
        backgroundColor: colorOpacity(customTheme.colors.primary, 0.2),
      },

      '&:hover': {
        //backgroundColor: colorOpacity(customTheme.colors.primary, 0.2),
        backgroundColor: isSelected
          ? colorOpacity(customTheme.colors.primary, 0.2)
          : 'hover',
        //color: isSelected ? '#fff' : '#000',
      },

      color: isSelected && !isMulti ? '#fff' : '#000',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      backgroundColor:
        isSelected && !isMulti
          ? colorOpacity(customTheme.colors.primary, 0.2)
          : '#fff',
      marginBottom: '1px',
      borderRadius: 6,
    };
  },
  control: (styles, props) => ({
    ...styles,
    border:
      (isAFilter && hasLeftMessage) || !showBorder
        ? 'none'
        : `1px solid ${
            props.isFocused
              ? customTheme.colors.primary
              : isAFilter
              ? customTheme.colors.filterBorder
              : customTheme.colors.formFieldBorder
          }`,
    borderRadius: customTheme.radii.fieldBorderRadius,
    minHeight: '0px',
    height: '100%',
    padding: 0,
    backgroundColor: 'inherit',
    opacity: props.isDisabled ? 0.9 : 'none',
    cursor: props.isDisabled ? 'not-allowed' : 'default',
    fontSize: fontSize,
    boxShadow: props.isFocused
      ? 'none' // `0 0 0 1px ${customTheme.colors.primary}`
      : 'none',

    '&:hover': {
      borderColor: `${customTheme.colors.primary}`,
    },
    '& *': {
      cursor: props.isDisabled ? 'not-allowed' : 'inherit',
    },
  }),
  container: (styles, { isMulti, hasValue, getValue, isDisabled }) => {
    const val = getValue()?.[0]?.value;
    return {
      ...styles,
      border: 'none',
      minHeight: '32px',
      height: height
        ? height
        : isMulti && hasValue && !showTotalSelected
        ? 'auto'
        : '32px',
      padding: 0,
      borderRadius: customTheme.radii.fieldBorderRadius,
      backgroundColor:
        /*hasValue && isAFilter && !!val
          ? colorOpacity(customTheme.colors.primary, 0.1)
          : */ 'inherit',
      //color: hasValue && isAFilter ? 'white' : 'inherit',
      color: 'inherit',
      fontSize: fontSize,
      cursor: isDisabled ? 'not-allowed' : 'default',
    };
  },
  valueContainer: (styles, props) => ({
    ...styles,
    height: '100%',
    padding: `0px 0px 0px 8px`,
    backgroundColor: 'inherit',
    cursor: props.isDisabled ? 'not-allowed' : 'auto',
    alignItems: 'center',
    borderRadius: '3px',
    //color: 'black',
  }),
  indicatorsContainer: provided => ({
    ...provided,
    padding: 0,
    height: '100%',
    backgroundColor: 'inherit',
    color:
      /*provided.hasValue && isAFilter ? 'white' :*/ customTheme.colors.gray[
        '200'
      ],
    borderRadius: customTheme.radii.fieldBorderRadius,
  }),
  indicatorSeparator: styles => ({
    ...styles,
    padding: 0,
    display: 'none',
  }),
  placeholder: styles => ({
    ...styles,
    color: customTheme.colors.placeholder,
  }),
  dropdownIndicator: provided => ({
    ...provided,
    padding: 0.5,
    paddingRight: 2,
    color:
      provided.hasValue && isAFilter ? 'white' : customTheme.colors.gray['250'],
  }),
  clearIndicator: provided => ({
    ...provided,
    paddingRight: '2px',
    paddingLeft: provided?.isMulti && isAFilter ? 0 : '3px',
  }),
  multiValue: styles => {
    if (showTotalSelected)
      return {
        ...styles,
        fontSize: fontSize,
        backgroundColor: 'transparent',
      };
    return {
      ...styles,
      fontSize: fontSize,
      backgroundColor: customTheme.colors.gray['50'],
      border: `1px solid ${customTheme.colors.gray['200']}`,
      borderRadius: '12px',
    };
  },
  multiValueContainer: (styles, props) => ({
    ...styles,
    opacity: props.isDisabled ? 0.9 : 'none',
    cursor: props.isDisabled ? 'not-allowed' : 'default',
  }),
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    'white-space': 'pre-wrap',
    color: data.color || customTheme.colors.primary,
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: data.color || customTheme.colors.primary,
    ':hover': {
      backgroundColor: data.color,
    },
  }),
  loadingIndicator: styles => {
    return {
      ...styles,
      // top: '50%',
    };
  },
});

export const defaultCheckBoxStyles = {
  size: 'md',
  //colorScheme: 'indigo',
  _focus: {
    outline: 'none',
    boxShadow: `0 0 0 1px ${customTheme.colors.primary}`,
  },
};
